import { StarBorderOutlined } from '@mui/icons-material';
import { ListItemIcon, ListItemText } from '@mui/material';

import { useMutation } from '@/hooks/mutationWithSnackbar';

import type { DocumentType } from '@/gql';
import { graphql } from '@/gql';

import { MaybeUsableMenuItem } from './MaybeUnusableMenuItem';

const UNPIN_FILE_MUTATION = graphql(`
  mutation unpinFile($data: UnpinFileInput) {
    unpinFile(params: $data) {
      file {
        ...fileFields
      }
    }
  }
`);

const UNPIN_FILE_MENU_ITEM_FILE_FRAGMENT = graphql(`
  fragment unpinFileMenuItemFileFields on File {
    ...fileFields
  }
`);

interface Props {
  file: DocumentType<typeof UNPIN_FILE_MENU_ITEM_FILE_FRAGMENT>;
  canEdit: boolean;
  canLockRoot: boolean;
  unusableExplanation: string | null;
  onClose: () => void;
}

export const UnpinFileMenuItem = ({
  file,
  canEdit,
  canLockRoot,
  unusableExplanation,
  onClose,
}: Props) => {
  const { _id: fileId } = file;

  const [unpinFile] = useMutation(UNPIN_FILE_MUTATION, {
    optimisticResponse: {
      unpinFile: {
        __typename: 'UnpinFileResult',
        file: {
          ...file,
          pinned: true,
        },
      },
    },
  });

  return (
    <>
      <MaybeUsableMenuItem
        isUsable={canEdit}
        isExpectedUsable={canLockRoot}
        unusableExplanation={unusableExplanation}
        onClick={() => {
          onClose();
          unpinFile({
            variables: {
              data: {
                file: fileId,
              },
            },
          });
        }}
      >
        <ListItemIcon>
          <StarBorderOutlined />
        </ListItemIcon>
        <ListItemText primary="Unpin from top of folder" />
      </MaybeUsableMenuItem>
    </>
  );
};
